'use client';

import PopupManager from '@/components/PopupManager/PopupManager';
import { type PopupStore, type PopupStoreApi, createPopupStore } from '@/stores/PopupStore';
import type { GlobalPopupsSettingsStoryblok } from '@/types/component-types-sb';
import { type ReactNode, createContext, useContext, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

export const PopupStoreContext = createContext<PopupStoreApi | undefined>(undefined);

export function PopupProvider({
  children,
  settings,
}: {
  children?: ReactNode;
  settings?: GlobalPopupsSettingsStoryblok['global_popup'];
}) {
  const [store] = useState(() => createPopupStore({ settings }));

  return (
    <PopupStoreContext.Provider value={store}>
      {children}
      <PopupManager />
    </PopupStoreContext.Provider>
  );
}

export function usePopupStore<T>(selector: (store: PopupStore) => T): T {
  const ctx = useContext(PopupStoreContext);
  if (!ctx) {
    throw new Error('usePopupStore must be used within PopupProvider');
  }
  return useStoreWithEqualityFn(ctx, selector, shallow);
}
